<eds-panel
  [enableHover]="false"
  [hasBorderRadius]="false"
  [hasBorders]="true"
  [hasPadding]="true"
  [hasShadows]="false"
  [style.display]="(isHandheld$ | async) ? 'none' : ''"
  theme="white"
>
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <eds-section-header
          theme="primary"
          [title]="
            'products.pop-and-sales-charge-at-breakpoints' | translate: fundId
          "
          [level]="6"
        ></eds-section-header>
      </div>
    </div>
    <div edsRow>
      <div edsCol>
        <table #tableResponsive class="table table--secondary">
          <thead>
            <tr class="table__tr">
              <th class="table__th">
                <p class="bold">
                  {{ "products.pricing-investment" | translate }}
                </p>
              </th>
              <th class="table__th">
                <p class="bold text-align-right">
                  {{ "products.pricing-sales-charge" | translate }}
                </p>
              </th>
              <th class="table__th">
                <p class="bold text-align-right">
                  {{ "products.pricing-pop" | translate }}
                </p>
              </th>
            </tr>
          </thead>
          <tbody class="table__body">
            <tr *ngFor="let item of salesChargeBreakPointsData">
              <td class="table__td">
                {{ item.breakPointYearPercentage }}
              </td>
              <td class="table__td text-align-right">
                <strong class="bold">{{
                  item.distributionRateBreakPoint | ftDashIfEmpty
                }}</strong>
              </td>
              <td class="table__td text-align-right">
                <strong class="bold">{{
                  item.popBreakPoint | ftDashIfEmpty
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</eds-panel>
<div edsGrid edsPadding edsPaddingTop="md" *ngIf="isHandheld$ | async">
  <div edsRow edsSpacing="md">
    <div edsCol>
      <eds-section-header
        [title]="
          'products.pop-and-sales-charge-at-breakpoints' | translate: fundId
        "
        [level]="6"
      ></eds-section-header>
    </div>
  </div>
  <div edsRow *ngFor="let card of cards; let cardIndex = index">
    <div edsCol>
      <eds-panel
        edsSpacing="sm"
        [hasBorders]="true"
        [hasBorderRadius]="false"
        [hasPadding]="true"
        theme="white"
      >
        <eds-info-item *ngFor="let item of card" [info]="item" edsSpacing="sm">
        </eds-info-item>
      </eds-panel>
    </div>
  </div>
</div>
